import { Range } from "immutable";

import { getAPI, getAllAPI } from "./api";
import { handleError, apiRequest } from "../lib/utils/request";
import { ValidationError } from "../../common/lib/validation";
import { setField } from "../../common/lib/redux-fields/actions";
import Alert from "react-s-alert";

export const GET_ARTICLES = "GET_ARTICLES";
export const GET_ARTICLES_SUCCESS = "GET_ARTICLES_SUCCESS";
export const GET_ARTICLES_ERROR = "GET_ARTICLES_ERROR";
export const GET_ARTICLES_FINALLY = "GET_ARTICLES_FINALLY";

export const GET_ARTICLE = "GET_ARTICLE";
export const GET_ARTICLE_SUCCESS = "GET_ARTICLE_SUCCESS";
export const GET_ARTICLE_ERROR = "GET_ARTICLE_ERROR";
export const GET_ARTICLE_FINALLY = "GET_ARTICLE_FINALLY";

export const SET_ARTICLE_PAGE = "SET_ARTICLE_PAGE";
export const SET_ARTICLE_SORT = "SET_ARTICLE_SORT";

export const getAll = (page) => async (dispatch, getState, utils) => {
  let data = getState().article.meta.toJS();
  if (page !== "" && page !== undefined) {
    data.currentPage = page;
    data.offset = (data.currentPage - 1) * 9;
  }

  const action = GET_ARTICLES;
  try {
    return await apiRequest(
      dispatch,
      getState,
      utils,
      action,
      null,
      getAllAPI,
      data,
      null,
      (body) => {
        return new ValidationError("all", "");
      }
    );
  } catch (error) {
    handleError(dispatch, getState, action, error);
  }
};

export const get = (data) => async (dispatch, getState, utils) => {
  const action = GET_ARTICLE;
  try {
    return await apiRequest(
      dispatch,
      getState,
      utils,
      action,
      null,
      getAPI,
      data,
      null,
      (body) => {
        return new ValidationError("all", "");
      }
    );
  } catch (error) {
    handleError(dispatch, getState, action, error);
  }
};

export const setPage = (page, onlySet) => async (dispatch, getState, utils) => {
  dispatch({
    type: SET_ARTICLE_PAGE,
    payload: { page },
  });

  if (onlySet === undefined) {
    dispatch(getAll());
  }
};

export const setSort = (field, dir) => async (dispatch, getState, utils) => {
  dispatch({
    type: SET_ARTICLE_PAGE,
    payload: { page: 1 },
  });

  dispatch({
    type: SET_ARTICLE_SORT,
    payload: { field, dir },
  });

  dispatch(getAll());
};



/** WEBPACK FOOTER **
 ** ./src/common/article/actions.js
 **/